import axios from "axios";
import { ApiResponse } from "../Models/api-response.model";
import { SessionService } from "./session.service";
const UseProductionUrl = false;
const nullResponse: ApiResponse<any> = {
  data: null,
  success: false,
  message: null,
};

const handleError = (error: any) => {
  if (error?.response?.status == 401) {
    SessionService.reset();
    window.location.href = "/login";
  }
};
// #doubt what is the use of httpservices?
export const HttpService = {
  get: <T>(url: string): Promise<ApiResponse<T>> => {
    // alert(mystate)
    return axios
      .get(
        (UseProductionUrl
          ? "https://tringapi.fsp.media/api/"
          : process.env.REACT_APP_APIURL) + url
      )
      .then((_) => {
        return _.data;
      })
      .catch((error) => {
        handleError(error);
        return nullResponse;
      });
  },
  post: <T>(url: string, data: any): Promise<ApiResponse<T>> => {
    return axios
      .post(
        (UseProductionUrl
          ? "https://tringapi.fsp.media/api/"
          : process.env.REACT_APP_APIURL) + url,
        data
      )
      .then((_) => {
        return _.data;
      })
      .catch((error) => {
        console.log("🚀 ~ error:", error);
        handleError(error);
        throw error;
      });
  },
  put: <T>(url: string, data: any): Promise<ApiResponse<T>> => {
    return axios
      .put(
        (UseProductionUrl
          ? "https://tringapi.fsp.media/api/"
          : process.env.REACT_APP_APIURL) + url,
        data
      )
      .then((_) => {
        return _.data;
      })
      .catch((error) => {
        handleError(error);
        return nullResponse;
      });
  },
  delete: <T>(url: string): Promise<ApiResponse<T>> => {
    return axios
      .delete(
        (UseProductionUrl
          ? "https://tringapi.fsp.media/api/"
          : process.env.REACT_APP_APIURL) + url
      )
      .then((_) => {
        return _.data;
      })
      .catch((error) => {
        handleError(error);
        return nullResponse;
      });
  },
};

export const ApplicationService = {
  get: <T>(url: string): Promise<ApiResponse<T>> => {
    return axios
      .get<ApiResponse<T>>(
        (UseProductionUrl
          ? "https://tringapi.fsp.media/api/"
          : process.env.REACT_APP_APIURL) + url,
        { headers: { Authorization: `Bearer ${SessionService.token()}` } }
      )
      .then((_) => {
        return _.data;
      })
      .catch((error) => {
        handleError(error);
        return nullResponse;
      });
  },
  post: <T>(url: string, data: any): Promise<ApiResponse<T>> => {
    return axios
      .post(
        (UseProductionUrl
          ? "https://tringapi.fsp.media/api/"
          : process.env.REACT_APP_APIURL) + url,
        data,
        { headers: { Authorization: `Bearer ${SessionService.token()}` } }
      )
      .then((_) => {
        return _.data;
      })
      .catch((error) => {
        handleError(error);
        return nullResponse;
      });
  },
  put: <T>(url: string, data: any): Promise<ApiResponse<T>> => {
    return axios
      .put(
        (UseProductionUrl
          ? "https://tringapi.fsp.media/api/"
          : process.env.REACT_APP_APIURL) + url,
        data,
        { headers: { Authorization: `Bearer ${SessionService.token()}` } }
      )
      .then((_) => {
        return _.data;
      })
      .catch((error) => {
        handleError(error);
        return nullResponse;
      });
  },
  delete: <T>(url: string): Promise<ApiResponse<T>> => {
    return axios
      .delete(
        (UseProductionUrl
          ? "https://tringapi.fsp.media/api/"
          : process.env.REACT_APP_APIURL) + url,
        { headers: { Authorization: `Bearer ${SessionService.token()}` } }
      )
      .then((_) => {
        return _.data;
      })
      .catch((error) => {
        handleError(error);
        return nullResponse;
      });
  },
};
